import { Sparkles, Users, Trophy } from "lucide-react";

export default function SystemInsight({ insight, forParent = false }) {
  if (!insight || (!(insight.rekomendasi_cita_cita?.length) && !(forParent && insight.panduan_orang_tua?.length))) return null;
  return (
    <div className="mb-6" data-testid="system-insight">
      <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#E25E3E]/10 text-[#E25E3E] text-sm font-medium mb-3">
        <Sparkles className="h-4 w-4" /> Kesimpulan & Analisa Asesmen
      </div>

      {insight.rekomendasi_cita_cita?.length > 0 && (
        <div className="clay-card p-6 mb-4">
          <h4 className="font-heading font-bold text-[#1A1C1A] mb-3">Rekomendasi iTi</h4>
          <div className="space-y-2.5">
            {insight.rekomendasi_cita_cita.map((c, i) => (
              <div key={i} className="flex items-start gap-2 flex-wrap">
                <span className="text-xs px-2.5 py-1 rounded-full bg-[#4A6B53]/10 text-[#4A6B53] font-medium shrink-0">{c.cita}</span>
                <span className="text-sm text-[#5C5F5C]">{c.alasan}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {forParent && insight.panduan_orang_tua?.length > 0 && (
        <div className="clay-card p-6 mb-4 bg-[#F4B942]/10 border-[#F4B942]/30">
          <h4 className="font-heading font-bold text-[#1A1C1A] mb-2 flex items-center gap-2"><Users className="h-4 w-4" /> Panduan untuk Orang Tua</h4>
          <ul className="space-y-1">
            {insight.panduan_orang_tua.map((s, i) => (
              <li key={i} className="flex items-start gap-2 text-sm text-[#1A1C1A]"><span className="text-[#E25E3E] mt-0.5">•</span> {s}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

// Analisa TryOut — penjabaran progres, ditampilkan di Bagian 4 (TryOut)
export function TryoutInsight({ insight, forParent = false }) {
  const t = insight?.tryout;
  if (!t) return null;
  return (
    <div className="clay-card p-6 mb-4 bg-[#1A1C1A] text-white border-[#1A1C1A]" data-testid="tryout-insight">
      <h4 className="font-heading font-bold mb-2 flex items-center gap-2"><Trophy className="h-4 w-4 text-[#F4B942]" /> {forParent ? "Analisa TryOut & Pengingat Orang Tua" : "Analisa Progres TryOut"}</h4>
      {t.ringkasan_progress && <p className="text-sm text-white/85 leading-relaxed mb-3">{t.ringkasan_progress}</p>}
      {forParent && t.pengingat_orang_tua?.length > 0 && (
        <div className="mb-3">
          <p className="text-xs text-white/60 mb-1">Yang perlu diingatkan ke anak:</p>
          <ul className="space-y-1">{t.pengingat_orang_tua.map((s, i) => (<li key={i} className="flex items-start gap-2 text-sm"><span className="text-[#F4B942] mt-0.5">•</span> {s}</li>))}</ul>
        </div>
      )}
      {t.fokus_perbaikan?.length > 0 && (
        <div>
          <p className="text-xs text-white/60 mb-1">Fokus perbaikan:</p>
          <div className="flex flex-wrap gap-1.5">{t.fokus_perbaikan.map((s, i) => (<span key={i} className="text-xs px-2.5 py-1 rounded-full bg-white/10">{s}</span>))}</div>
        </div>
      )}
    </div>
  );
}
